export default __webpack_public_path__ + "static/blob4-9e504aa0bf251f45b290256c41a14c2e.svg";